import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {VisitPlanCellModel} from "../../models/visit-plan-cell.model";

@Injectable({providedIn: 'root'})
export class VisitPlanAccountCellChannelService extends EntitiesChannel<VisitPlanCellModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "visitSlot_changed";
  }

  getPartialChannelName(): String {
    return "";
  }

  getCreateChannelName(): String {
    return "visitSlot_created";
  }

}
